var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfilePicGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M26,50A24,24,0,1,0,2,26,24,24,0,0,0,26,50Zm7.2-28.8A7.2,7.2,0,1,1,26,14,7.2,7.2,0,0,1,33.2,21.2ZM11.6,38a18,18,0,0,1,28.8,0,18,18,0,0,1-28.8,0Z",
    transform: "translate(-2 -2)",
    fill: "#b07f4a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfilePicGold);
export default __webpack_public_path__ + "static/media/userProfilePicGold.54b0d82a04aef90edad098dfce325fdf.svg";
export { ForwardRef as ReactComponent };